<template>
  <section class="banner-swiper">
    <div class="banner-wrapper">
      <template v-if="banners.length">
        <div
          v-for="(banner, index) in banners"
          :key="banner.id"
          class="banner-slide"
          :class="{ 'banner-slide--active': index === currentIndex }"
          @click="openLink(banner.link)"
        >
          <img :src="banner.img || 'https://picsum.photos/1200/450?random=' + banner.id" :alt="banner.alt">
          <div class="banner-overlay">
            <div class="banner-title">{{ banner.alt || '广告' }}</div>
          </div>
        </div>
        <div class="banner-controls">
          <button class="banner-arrow banner-arrow--left" @click.stop="onPrevClick">‹</button>
          <button class="banner-arrow banner-arrow--right" @click.stop="onNextClick">›</button>
        </div>
        <div class="dots">
          <button
            v-for="(banner, index) in banners"
            :key="banner.id"
            class="dot"
            :class="{ 'dot--active': index === currentIndex }"
            @click="go(index)"
          />
        </div>
      </template>
      <div v-else class="banner-empty">
        <p>暂无广告</p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BannerSwiper',
  data() {
    return {
      currentIndex: 0,
      intervalId: null,
      touchStartX: 0,
      touchEndX: 0
    }
  },
  watch: {
    banners: {
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.currentIndex = 0
          this.start()
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(['getBannersList']),
    banners() {
      return Array.isArray(this.getBannersList) ? this.getBannersList : []
    }
  },
  mounted() {
    if (this.banners.length > 0) {
      this.start()
    }
    this.$el.addEventListener('touchstart', this.handleTouchStart, false)
    this.$el.addEventListener('touchend', this.handleTouchEnd, false)
  },
  beforeDestroy() {
    this.stop()
    this.$el.removeEventListener('touchstart', this.handleTouchStart, false)
    this.$el.removeEventListener('touchend', this.handleTouchEnd, false)
  },
  methods: {
    start() {
      this.stop()
      if (this.banners.length < 1) return
      this.intervalId = window.setInterval(() => this.next(), 7000)
    },
    stop() {
      if (this.intervalId) {
        window.clearInterval(this.intervalId)
        this.intervalId = null
      }
    },
    next() {
      const length = this.banners.length
      if (!length) return
      this.currentIndex = (this.currentIndex + 1) % length
    },
    prev() {
      const length = this.banners.length
      if (!length) return
      this.currentIndex = (this.currentIndex - 1 + length) % length
    },
    onPrevClick() {
      this.prev()
      this.start()
    },
    onNextClick() {
      this.next()
      this.start()
    },
    go(index) {
      this.currentIndex = index
      this.start()
    },
    openLink(link) {
      if (!link) return
      window.open(link, '_blank')
    },
    handleTouchStart(e) {
      this.touchStartX = e.changedTouches[0].screenX
    },
    handleTouchEnd(e) {
      this.touchEndX = e.changedTouches[0].screenX
      this.handleSwipe()
    },
    handleSwipe() {
      const diff = this.touchStartX - this.touchEndX
      const threshold = 50
      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          this.next()
        } else {
          this.prev()
        }
        this.start()
      }
    }
  }
}
</script>

<style scoped>
.banner-swiper {
  width: 100%;
  background: radial-gradient(circle at top, #1e3a8a, #020617 58%);
}

.banner-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.75);
  aspect-ratio: 16 / 6;
}

.banner-slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transform: scale(1.03);
  transition: opacity 0.6s ease, transform 0.6s ease;
  cursor: pointer;
  z-index: 0;
  pointer-events: none;
}

.banner-slide--active {
  opacity: 1;
  transform: scale(1);
  z-index: 1;
  pointer-events: auto;
}

.banner-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-overlay {
  position: absolute;
  left: 40px;
  bottom: 40px;
  padding: 18px 22px;
  border-radius: 16px;
  background: linear-gradient(120deg, rgba(15, 23, 42, 0.92), rgba(15, 23, 42, 0.72));
  color: #e5e9f0;
  max-width: 420px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.9);
}

.banner-title {
  font-size: 22px;
  font-weight: 600;
}

.banner-controls {
  position: absolute;
  inset: 0;
  z-index: 10;
  pointer-events: none;
}

.banner-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 11;
  pointer-events: auto;
  opacity: 1;
  visibility: visible;
  width: 40px;
  height: 40px;
  border-radius: 999px;
  border: none;
  background: rgba(75, 85, 99, 0.86);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.35);
  font-size: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.18s ease, transform 0.18s ease, box-shadow 0.18s ease;
}

.banner-arrow--left { left: 18px; }
.banner-arrow--right { right: 18px; }

.banner-arrow:hover {
  background: rgba(55, 65, 81, 0.95);
  transform: translateY(-50%) scale(1.05);
  box-shadow: 0 12px 26px rgba(17, 24, 39, 0.55);
}

.dots {
  position: absolute;
  left: 50%;
  bottom: 18px;
  transform: translateX(-50%);
  display: flex;
  gap: 8px;
}

.dot {
  width: 9px;
  height: 9px;
  border-radius: 999px;
  border: none;
  background: rgba(148, 163, 184, 0.6);
  cursor: pointer;
  transition: background-color 0.18s ease, transform 0.18s ease, width 0.18s ease;
}

.dot--active {
  width: 18px;
  background: linear-gradient(90deg, #38bdf8, #22c55e);
  transform: translateY(-1px);
}

.banner-empty {
  min-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  padding: 40px;
}

@media (max-width: 1024px) {
  .banner-wrapper { margin-inline: 16px; }
  .banner-overlay { left: 24px; bottom: 28px; padding: 14px 18px; }
}

@media (max-width: 768px) {
  .banner-wrapper { 
    margin-inline: 12px; 
    border-radius: 14px;
    aspect-ratio: 16 / 9;
  }
  .banner-overlay { left: 16px; bottom: 18px; right: 16px; max-width: none; padding: 10px 12px; }
  .banner-title { font-size: 16px; }
  .banner-arrow {
    width: 34px;
    height: 34px;
    font-size: 20px;
  }
  .banner-arrow--left { left: 10px; }
  .banner-arrow--right { right: 10px; }
}

@media (max-width: 480px) {
  .banner-wrapper {
    margin-inline: 8px;
    aspect-ratio: 16 / 10;
  }
  .banner-overlay { left: 12px; bottom: 12px; padding: 8px 10px; }
  .banner-title { font-size: 14px; }
  .dots { bottom: 12px; gap: 6px; }
  .dot { width: 6px; height: 6px; }
  .dot--active { width: 14px; }
}
</style>
